/**
 * @module mapbs.components.layertree.mapbsLayertreeCustomization
 */

/**
 * Customization (override of functions) for the gmf layertree component.
 */

import GmfLayertreeController from 'gmf/layertree/component.js';
import gmfPermalinkPermalink from 'gmf/permalink/Permalink';
import LayertreeController, {
    getFirstParentTree,
} from 'ngeo/layertree/Controller.js';
import olSourceImageWMS from 'ol/source/ImageWMS.js';
import angular from 'angular';

const moduleLayertreecustom = angular.module('mapbsLayertreeCustomizationModule', [
    GmfLayertreeController.name,
    LayertreeController.name,
    gmfPermalinkPermalink.name
]);

class Controller {
    /**
     * A list of layer name (name from gmf admin, not from mapserver) bound to a
     * layers's dimension.
     * Example:  {'my_time_layer': 'time_dimensions_for_my_layer'}
     * @type {!Object.<string, string>}
     * @private
     */
    DIMENSIONS_FOR_WMST_LAYERS = {
        // eslint-disable-line no-undef
        'BW_Allmendbewilligungen_Bauinstallation': 'TIME',
        'BW_Allmendbewilligungen_BoulevardVerkaufsflaeche': 'TIME',
        'BW_Allmendbewilligungen_OeffentlicheBaustelle': 'TIME',
        'BW_Allmendbewilligungen_Umleitung': 'TIME',
        'BW_Allmendbewilligungen_Veranstaltung': 'TIME',
        'BW_Allmendbewilligungen_Weitere': 'TIME',
        'BW_Aufgrabungssperren_SperrungDurchErledigteAufgrabung': 'TIME',
        'BW_Aufgrabungssperren_SperrungFuerZukuenftigeAufgrabung': 'TIME',
        'BW_Sperrverletzung': 'TIME',
        'BW_Sperrverletzung_area': 'TIME',
        'IA_Massnahmenplan': 'TIME',
        'IA_Teilsystemmassnahmen_Abwassserableitungsanlagen': 'TIME',
        'IA_Teilsystemmassnahmen_Elektrizitaet': 'TIME',
        'IA_Teilsystemmassnahmen_ElektrizitaetTelekomIWB': 'TIME',
        'IA_Teilsystemmassnahmen_Fernwaerme': 'TIME',
        'IA_Teilsystemmassnahmen_Gas': 'TIME',
        'IA_Teilsystemmassnahmen_Gleisanlagen': 'TIME',
        'IA_Teilsystemmassnahmen_Kunstbauten': 'TIME',
        'IA_Teilsystemmassnahmen_Lichtsignalanlagen': 'TIME',
        'IA_Teilsystemmassnahmen_Nationalstrassen': 'TIME',
        'IA_Teilsystemmassnahmen_Strassen': 'TIME',
        'IA_Teilsystemmassnahmen_Strassenbegleitgruen': 'TIME',
        'IA_Teilsystemmassnahmen_Umgestaltung': 'TIME',
        'IA_Teilsystemmassnahmen_Wasser': 'TIME',
        'IA_Teilsystemmassnahmen_Wasserbauten': 'TIME',
        'IA_Teilsystemmassnahmen_Telecom_Cablecom': 'TIME',
        'IA_Teilsystemmassnahmen_Telecom_CATV': 'TIME',
        'IA_Teilsystemmassnahmen_Telecom_Colt': 'TIME',
        'IA_Teilsystemmassnahmen_Telecom_IWB': 'TIME',
        'IA_Teilsystemmassnahmen_Telecom_Sunrise': 'TIME',
        'IA_Teilsystemmassnahmen_Telecom_Swisscom': 'TIME',
        'IA_Teilsystemmassnahmen_Bettingen_Abwassserableitungsanlagen': 'TIME',
        'IA_Teilsystemmassnahmen_Bettingen_ElektrizitaetOeB': 'TIME',
        'IA_Teilsystemmassnahmen_Bettingen_Fernwaerme': 'TIME',
        'IA_Teilsystemmassnahmen_Bettingen_Strassen': 'TIME',
        'IA_Teilsystemmassnahmen_Bettingen_TelekomKommNetz': 'TIME',
        'IA_Teilsystemmassnahmen_Riehen_Abwassserableitungsanlagen': 'TIME',
        'IA_Teilsystemmassnahmen_Riehen_ElektrizitaetOeB': 'TIME',
        'IA_Teilsystemmassnahmen_Riehen_Fernwaerme': 'TIME',
        'IA_Teilsystemmassnahmen_Riehen_Strassen': 'TIME',
        'IA_Teilsystemmassnahmen_Riehen_TelekomKommNetz': 'TIME',
        'IA_Teilsystemmassnahmen_Ausstattung': 'TIME',
        'IA_Erhaltungsplan': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Arealentwicklung': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Entsorgung': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Mobilitaet': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Mobilitaet-IV': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Mobilitaet-OeV': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Stadtgestaltung': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Stadtgruen': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Umgestaltung': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Verkehrssicherheit': 'TIME',
        'IA_WirkungsverantwortlichenMassnahmen_Versorgung': 'TIME',
        'BA_Baumpflege_Baumkontrolle_fd': 'TIME',
        'BA_Baumpflege_Baumschnitt_fd': 'TIME',
        'BA_Baumpflege_Giessen_fd': 'TIME',
        'BA_Baumpflege_Kronenverankerung_fd': 'TIME',
        'IA_Massnahmenplan_aktuell_fd': 'TIME',
        'IA_Massnahmenplan_sonstige_fd': 'TIME',
        'IA_Massnahmenplan_aktuell_plot': 'TIME',
        'IA_Erhaltungsplan_aktuell_fd': 'TIME',
        'IA_Erhaltungsplan_sonstige_fd': 'TIME',
        'IA_TSM_Abwassserableitungsanlagen_aktuell_fd': 'TIME',
        'IA_TSM_Abwassserableitungsanlagen_sonstige_fd': 'TIME',
        'IA_TSM_Elektrizitaet_aktuell_fd': 'TIME',
        'IA_TSM_Elektrizitaet_sonstige_fd': 'TIME',
        'IA_TSM_ElektrizitaetTelekomIWB_aktuell_fd': 'TIME',
        'IA_TSM_ElektrizitaetTelekomIWB_sonstige_fd': 'TIME',
        'IA_TSM_Fernwaerme_aktuell_fd': 'TIME',
        'IA_TSM_Fernwaerme_sonstige_fd': 'TIME',
        'IA_TSM_Gas_aktuell_fd': 'TIME',
        'IA_TSM_Gas_sonstige_fd': 'TIME',
        'IA_TSM_Gleisanlagen_aktuell_fd': 'TIME',
        'IA_TSM_Gleisanlagen_sonstige_fd': 'TIME',
        'IA_TSM_Kunstbauten_aktuell_fd': 'TIME',
        'IA_TSM_Kunstbauten_sonstige_fd': 'TIME',
        'IA_TSM_Lichtsignalanlagen_aktuell_fd': 'TIME',
        'IA_TSM_Lichtsignalanlagen_sonstige_fd': 'TIME',
        'IA_TSM_Nationalstrassen_aktuell_fd': 'TIME',
        'IA_TSM_Nationalstrassen_sonstige_fd': 'TIME',
        'IA_TSM_Strassen_aktuell_fd': 'TIME',
        'IA_TSM_Strassen_sonstige_fd': 'TIME',
        'IA_TSM_Strassenbegleitgruen_aktuell_fd': 'TIME',
        'IA_TSM_Strassenbegleitgruen_sonstige_fd': 'TIME',
        'IA_TSM_Umgestaltung_aktuell_fd': 'TIME',
        'IA_TSM_Umgestaltung_sonstige_fd': 'TIME',
        'IA_TSM_Wasser_aktuell_fd': 'TIME',
        'IA_TSM_Wasser_sonstige_fd': 'TIME',
        'IA_TSM_Wasserbauten_aktuell_fd': 'TIME',
        'IA_TSM_Wasserbauten_sonstige_fd': 'TIME',
        'IA_TSM_Telecom_Cablecom_aktuell_fd': 'TIME',
        'IA_TSM_Telecom_Cablecom_sonstige_fd': 'TIME',
        'IA_TSM_Telecom_CATV_aktuell_fd': 'TIME',
        'IA_TSM_Telecom_CATV_sonstige_fd': 'TIME',
        'IA_TSM_Telecom_Colt_aktuell_fd': 'TIME',
        'IA_TSM_Telecom_Colt_sonstige_fd': 'TIME',
        'IA_TSM_Telecom_IWB_aktuell_fd': 'TIME',
        'IA_TSM_Telecom_IWB_sonstige_fd': 'TIME',
        'IA_TSM_Telecom_Sunrise_aktuell_fd': 'TIME',
        'IA_TSM_Telecom_Sunrise_sonstige_fd': 'TIME',
        'IA_TSM_Telecom_Swisscom_aktuell_fd': 'TIME',
        'IA_TSM_Telecom_Swisscom_sonstige_fd': 'TIME',
        'IA_TSM_Bettingen_Abwasserableitungsanlagen_aktuell_fd': 'TIME',
        'IA_TSM_Bettingen_Abwasserableitungsanlagen_sonstige_fd': 'TIME',
        'IA_TSM_Bettingen_ElektrizitaetOEB_aktuell_fd': 'TIME',
        'IA_TSM_Bettingen_ElektrizitaetOEB_sonstige_fd': 'TIME',
        'IA_TSM_Bettingen_Fernwaerme_aktuell_fd': 'TIME',
        'IA_TSM_Bettingen_Fernwaerme_sonstige_fd': 'TIME',
        'IA_TSM_Bettingen_Strassen_aktuell_fd': 'TIME',
        'IA_TSM_Bettingen_Strassen_sonstige_fd': 'TIME',
        'IA_TSM_Bettingen_TelekomKommNetz_aktuell_fd': 'TIME',
        'IA_TSM_Bettingen_TelekomKommNetz_sonstige_fd': 'TIME',
        'IA_TSM_Riehen_Abwasserableitungsanlagen_aktuell_fd': 'TIME',
        'IA_TSM_Riehen_Abwasserableitungsanlagen_sonstige_fd': 'TIME',
        'IA_TSM_Riehen_ElektrizitaetOEB_aktuell_fd': 'TIME',
        'IA_TSM_Riehen_ElektrizitaetOEB_sonstige_fd': 'TIME',
        'IA_TSM_Riehen_Fernwaerme_aktuell_fd': 'TIME',
        'IA_TSM_Riehen_Fernwaerme_sonstige_fd': 'TIME',
        'IA_TSM_Riehen_Strassen_aktuell_fd': 'TIME',
        'IA_TSM_Riehen_Strassen_sonstige_fd': 'TIME',
        'IA_TSM_Riehen_TelekomKommNetz_aktuell_fd': 'TIME',
        'IA_TSM_Riehen_TelekomKommNetz_sonstige_fd': 'TIME',
        'IA_TSM_Ausstattung_aktuell_fd': 'TIME',
        'IA_TSM_Ausstattung_sonstige_fd': 'TIME',
        'IA_WVM_Arealentwicklung_aktuell_fd': 'TIME',
        'IA_WVM_Arealentwicklung_sonstige_fd': 'TIME',
        'IA_WVM_Entsorgung_aktuell_fd': 'TIME',
        'IA_WVM_Entsorgung_sonstige_fd': 'TIME',
        'IA_WVM_Mobilitaet-IV_aktuell_fd': 'TIME',
        'IA_WVM_Mobilitaet-IV_sonstige_fd': 'TIME',
        'IA_WVM_Mobilitaet-OeV_aktuell_fd': 'TIME',
        'IA_WVM_Mobilitaet-OeV_sonstige_fd': 'TIME',
        'IA_WVM_Stadtgestaltung_aktuell_fd': 'TIME',
        'IA_WVM_Stadtgestaltung_sonstige_fd': 'TIME',
        'IA_WVM_Stadtgruen_aktuell_fd': 'TIME',
        'IA_WVM_Stadtgruen_sonstige_fd': 'TIME',
        'IA_WVM_Umgestaltung_aktuell_fd': 'TIME',
        'IA_WVM_Umgestaltung_sonstige_fd': 'TIME',
        'IA_WVM_Verkehrssicherheit_aktuell_fd': 'TIME',
        'IA_WVM_Verkehrssicherheit_sonstige_fd': 'TIME',
        'IA_WVM_Versorgung_aktuell_fd': 'TIME',
        'IA_WVM_Versorgung_sonstige_fd': 'TIME',
        'IA_IMWZ_Kunstbauten_InVergangenheitVorgeschlagene_fd': 'TIME',
        'IA_IMWZ_Abwasserableitungsanlagen_InVergangenheitVorgeschlagene_fd': 'TIME',
        'IA_IMWZ_Strassen_InVergangenheitVorgeschlagene_fd': 'TIME',
        'IA_IMWZ_Gleisanlagen_InVergangenheitVorgeschlagene_fd': 'TIME',
        'IA_Massnahmenplan_readonly': 'TIME',
        'IA_Erhaltungsplan_readonly': 'TIME',
        'IA_TSMassnahmen_readonly': 'TIME',
        'IA_WVMassnahmen_readonly': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_DENV_RR_ohne': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_DENV_RR_mit': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_DENV_AF_ohne': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_DENV_AF_mit': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_CHIKV_RR_ohne': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_CHIKV_RR_mit': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_CHIKV_AF_ohne': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_CHIKV_AF_mit': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_ZIKV_RR_ohne': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_ZIKV_RR_mit': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_ZIKV_AF_ohne': 'TIME',
        'IK_UebertragbareKrankheiten_Fall_ZIKV_AF_mit': 'TIME',
        'IK_UebertragbareKrankheiten_Aufenthaltsorte_ZIKV': 'TIME',
        'IK_UebertragbareKrankheiten_Aufenthaltsorte_CHIKV': 'TIME',
        'IK_UebertragbareKrankheiten_Aufenthaltsorte_DENV': 'TIME',
        'IK_UebertragbareKrankheiten_Legionellen_Aufenthaltsort_positiv': 'TIME',
        'IK_UebertragbareKrankheiten_Legionellen_Aufenthaltsort_negativ': 'TIME',
        'IK_UebertragbareKrankheiten_Legionellen_Aufenthaltsort_nichtBeprobt': 'TIME',
        'IK_UebertragbareKrankheiten_Legionellen_Aufenthaltsort_unbekannt': 'TIME',
        'IK_UebertragbareKrankheiten_Legionellen_Wohnort_positiv': 'TIME',
        'IK_UebertragbareKrankheiten_Legionellen_Wohnort_negativ': 'TIME',
        'IK_UebertragbareKrankheiten_Legionellen_Wohnort_nichtBeprobt': 'TIME',
        'IK_UebertragbareKrankheiten_Legionellen_Wohnort_unbekannt': 'TIME',
        'IK_UebertragbareKrankheiten_Legionellen_Filter': 'TIME',
        'LF_Bildmittelpunkt_SchwarzWeiss': 'TIME',
        'LF_Footprint_SchwarzWeiss': 'TIME',
        'LF_Bildmittelpunkt_farbig': 'TIME',
        'LF_Footprint_farbig': 'TIME',
        'LF_Bildmittelpunkt_infrarot': 'TIME',
        'LF_Footprint_infrarot': 'TIME',
        'LF_Bildmittelpunkt_schraeg': 'TIME',
        'LF_Footprint_schraeg': 'TIME',
        'LF_Bildmittelpunkte': 'TIME',
        'RM_Geschwindigkeitsmonitoring': 'TIME',
        'US_Unfallschwerpunkte': 'TIME',
        'TI_Tigermuecke_Monitoring_Meldung': 'TIME',
        'TI_Tigermuecke_Monitoring_Nachuntersuchung': 'TIME',
        'TI_Tigermuecke_Monitoring_Fallen': 'TIME',
        'SY_SmileyGeschwindigkeitsanzeigen_inBetrieb': 'TIME',
        'SY_SmileyGeschwindigkeitsanzeigen_ausserBetrieb': 'TIME',
        'VU_SchleuderunfallSelbstunfall': 'TIME',
        'VU_UeberholunfallFahrstreifenwechsel': 'TIME',
        'VU_Auffahrunfall': 'TIME',
        'VU_Abbiegeunfall': 'TIME',
        'VU_Einbiegeunfall': 'TIME',
        'VU_UeberquerenDerFahrbahn': 'TIME',
        'VU_Frontalkollision': 'TIME',
        'VU_Parkierunfall': 'TIME',
        'VU_Fussgaengerunfall': 'TIME',
        'VU_Tierunfall': 'TIME',
        'VU_Andere': 'TIME'
    };

    /**
     * The default format for dimensions is date (yyyy-mm-dd/yyyy-mm-dd)
     * This list contains the layer name if the format should be year only (yyyy/yyyy)
     */
    DIMENSIONS_FORMAT_YEAR_ONLY = [
        // eslint-disable-line no-undef
        'LF_Bildmittelpunkt_SchwarzWeiss',
        'LF_Footprint_SchwarzWeiss',
        'LF_Bildmittelpunkt_farbig',
        'LF_Footprint_farbig',
        'LF_Bildmittelpunkt_infrarot',
        'LF_Footprint_infrarot',
        'LF_Bildmittelpunkt_schraeg',
        'LF_Footprint_schraeg',
        'LF_Bildmittelpunkte',
        'US_Unfallschwerpunkte',
        'TI_Tigermuecke_Monitoring_Meldung',
        'TI_Tigermuecke_Monitoring_Nachuntersuchung',
        'TI_Tigermuecke_Monitoring_Fallen',
        'VU_SchleuderunfallSelbstunfall',
        'VU_UeberholunfallFahrstreifenwechsel',
        'VU_Auffahrunfall',
        'VU_Abbiegeunfall',
        'VU_Einbiegeunfall',
        'VU_UeberquerenDerFahrbahn',
        'VU_Frontalkollision',
        'VU_Parkierunfall',
        'VU_Fussgaengerunfall',
        'VU_Tierunfall',
        'VU_Andere'
    ];

    updateTimeData(layertreeCtrl, time, gmfLayertreeCtrl) {
        this.updateWMSTimeLayerState(layertreeCtrl, time);
        gmfLayertreeCtrl.gmfPermalink_.refreshLayerTime(layertreeCtrl, time);
    }

    /**
   * @param {ngeoLayertreeController} layertreeCtrl ngeo layertree controller
   * @param {{start : number, end : number}} time The start
   */
    updateWMSTimeLayerState(layertreeCtrl, time) {
        if (!time) {
            return;
        }
        const dataSource = layertreeCtrl.getDataSource();
        if (dataSource) {
            // ----- customized part (start) -----
            const layername = dataSource.name;
            const dimension = this.DIMENSIONS_FOR_WMST_LAYERS[layername];

            if (dimension) {
                let layer = layertreeCtrl.layer;
                if (!layer) {
                    const tree = getFirstParentTree(layertreeCtrl);
                    layer = tree.layer;
                }
                const source = layer.getSource();
                if (source && source instanceof olSourceImageWMS) {
                    let pgsqlTime = null;
                    if (this.DIMENSIONS_FORMAT_YEAR_ONLY.includes(layername)) {
                        // Year format only
                        pgsqlTime = this.formatTimestampForPostreSQLYearOnly_(time);
                    } else {
                        // Date format
                        pgsqlTime = this.formatTimestampForPostreSQL_(time);
                    }
                    // update query url
                    dataSource.dimensionsConfig[dimension] = pgsqlTime;
                    // update getmap url
                    const params = {};
                    params[dimension] = pgsqlTime;
                    /** @type {import("ol/source/ImageWMS.js").default} */ (
                        source
                    ).updateParams(params);
                }
                // ----- customized part (end) -----
            } else {
                // Update time value to use WMT-T
                dataSource.timeRangeValue = time;
            }
        } else if (layertreeCtrl.children) {
            for (let i = 0, ii = layertreeCtrl.children.length; i < ii; i++) {
                this.updateWMSTimeLayerState(layertreeCtrl.children[i], time);
            }
        }
    }

    /**
     * @param {{start : number, end : number}} time the time
     * @return {string} the postgresql timestamp '2006-4-20' (value), or
     *   '2006-4-20/2008-4-20' (range).
     * @private
     */
    formatTimestampForPostreSQL_(time) {
        const s = new Date(time.start);
        let psqlTimestamp = `${s.getFullYear()}-${s.getMonth() + 1}-${s.getDate()}`;
        if (time.end) {
            const e = new Date(time.end);
            psqlTimestamp += `/${e.getFullYear()}-${e.getMonth() + 1}-${e.getDate()}`;
        }
        return psqlTimestamp;
    }

    /**
     * @param {{start : number, end : number}} time the time
     * @return {string} the postgresql timestamp '2006' (value), or '2006/2008' (range).
     * @private
     */
    formatTimestampForPostreSQLYearOnly_(time) {
        const s = new Date(time.start);
        let psqlTimestamp = `${s.getFullYear()}`;
        if (time.end) {
            const e = new Date(time.end);
            psqlTimestamp += `/${e.getFullYear()}`;
        }
        return psqlTimestamp;
    }
}

moduleLayertreecustom.controller('mapbsLayertreeCustomization', Controller);

export default moduleLayertreecustom;
